import { Button, Input, Text } from "@microbeta/ui";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineAccountCircle } from "react-icons/md";
import { Link } from "react-router-dom";
import { paths } from "../../../../../shared/utils/routing";
import styles from "../request-reset-password.module.scss";

type Props = {
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  onSendInstructions: () => void;
};

const EnterEmailContent = ({ email, setEmail, onSendInstructions }: Props) => {
  const { t } = useTranslation();
  const handleSendPressed = () => {
    onSendInstructions();
  };

  return (
    <>
      <Input
        type="email"
        inputContainerClassName={styles.input}
        value={email}
        placeholder={t("enterEmailContent.emailPlaceholder")}
        label={t("enterEmailContent.emailLabel")}
        onChange={(e) => setEmail(e.currentTarget.value)}
        leftComponent={<MdOutlineAccountCircle />}
      />
      <Button
        className={styles.sendInstructionsButton}
        onClick={handleSendPressed}
        variant="primary"
        size="small"
        type="submit"
      >
        {t("enterEmailContent.sendInstructionsButton")}
      </Button>
      <Link to={paths.signin}>
        <Text className={styles.signInLink} as="span" variant="small">
          {t("enterEmailContent.backToLogin")}
        </Text>
      </Link>
    </>
  );
};

export default EnterEmailContent;
